import { AnalyticIdentifier } from '@common/neo.tax';

import { useAnalyticId } from '@neo.tax/shared/state';

interface AccountingProviderIds {
  quickbooksRadioId: string;
  netsuiteRadioId: string;
  csvRadioId: string;
}

export const useAccountingProviderIds = (): AccountingProviderIds => ({
  quickbooksRadioId: useAnalyticId(AnalyticIdentifier.RTC_SELECT_LINK_QUICKBOOKS),
  netsuiteRadioId: useAnalyticId(AnalyticIdentifier.RTC_SELECT_LINK_NETSUITE),
  csvRadioId: useAnalyticId(AnalyticIdentifier.RTC_SELECT_UPLOAD_ACCOUNTING_CSV),
});
